import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const CartGetList = createAsyncThunk(
  "CartGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: API_URL.BASEURL + API_URL.CART.GET_LIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
export const CartSave = createAsyncThunk(
  "CartSave",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CART.SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const CartDetailDelete = createAsyncThunk(
  "CartDetailDelete",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CART.DELETE_CART_DETAIL,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  CartGetListData: {
    data: null,
    error: null,
  },
  CartSaveData: {
    data: null,
    error: null,
  },
  CartDetailDeleteData: {
    data: null,
    error: null,
  },
};

const CartSlice = createSlice({
  name: "CART",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    //   setGetWorkFlowByID: (state) => {
    //     state.GetWorkFlowByIDData.data = null;
    //   },
  },

  extraReducers: (builder) => {
    builder
      .addCase(CartGetList.fulfilled, (state, action) => {
        state.CartGetListData.data = action.payload;
      })
      .addCase(CartGetList.rejected, (state, action) => {
        state.CartGetListData.error = action.error.message;
      })
      .addCase(CartSave.fulfilled, (state, action) => {
        state.CartSaveData.data = action.payload;
      })
      .addCase(CartSave.rejected, (state, action) => {
        state.CartSaveData.error = action.error.message;
      })
      .addCase(CartDetailDelete.fulfilled, (state, action) => {
        state.CartDetailDeleteData.data = action.payload;
      })
      .addCase(CartDetailDelete.rejected, (state, action) => {
        state.CartDetailDeleteData.error = action.error.message;
      });
  },
});

// export const { setLoader } = CartSlice.actions;
export default CartSlice.reducer;
